









import Vue from 'vue'

export default Vue.extend({
  name: 'CommonListTextAnswer',
  props: {
    question: { type: [Array, Object] },
    answer: [Object, Array, Number],
    correctAnswer: [Object, Array, Number],
    answerType: { type: String, default: 'student' },
  },
  computed: {
    currentAnswer() {
      return this.answerType === 'student' ? this.answer : this.correctAnswer
    },
    answerData() {
      try {
        if (this.answerType === 'student') {
          if (Array.isArray(this.answer)) {
            const arr: string[] = []
            this.answer.forEach((el: any) => {
              const value = parseInt(el, 10)
              if (!isNaN(value)) {
                arr.push(this.question.options[value])
              } else {
                arr.push(' - ')
              }
            })
            return arr.join(';')
          }
        }
        if (this.answerType === 'correct') {
          if (Array.isArray(this.correctAnswer)) {
            const arr: string[] = []
            this.correctAnswer.forEach((el: any) => {
              const value = parseInt(el, 10)
              if (!isNaN(value)) {
                arr.push(this.question.options[value])
              } else {
                arr.push(' - ')
              }
            })
            return arr.join(';')
          }
        }
        return this.answerType === 'student' ? this.answer : this.correctAnswer
      } catch (e) {
        console.error(e)
        return []
      }
    },
  },
})
